const API_URL = "https://app.windtransfer.net/ajax/log-error.php";

interface ErrorData {
  type: string;
  message: string;
  stack?: string;
  source?: string;
  line?: number;
  col?: number;
  component?: string;
  folder_id?: string;
}

function getFolderId(): string {
  const params = new URLSearchParams(window.location.search);
  return params.get("ID") || "";
}

const IGNORE_PATTERNS = [
  "cashback",
  "extension",
  "chrome-extension",
  "moz-extension",
  "safari-extension",
  "honey",
  "igraal",
  "safari-web-extension",
  "the operation is insecure",
  "access is denied for this document",
  "tawk.to",
  "embed.tawk.to",
];

function isExtensionError(data: ErrorData): boolean {
  const text = `${data.message} ${data.stack || ""} ${data.source || ""}`.toLowerCase();
  return IGNORE_PATTERNS.some((pattern) => text.includes(pattern));
}

export function trackError(data: ErrorData) {
  if (isExtensionError(data)) return;

  const payload = {
    ...data,
    folder_id: data.folder_id || getFolderId(),
    url: window.location.href,
  };

  // Send to Umami (short version for dashboard)
  window.umami?.track(data.type, {
    message: data.message.slice(0, 100),
    folder_id: payload.folder_id,
  });

  // Send full details to PHP backend
  fetch(API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  }).catch(() => {});
}
